import {CaseFormValidator} from '../../utils/validators'
import * as _ from "lodash";

interface Action {
    payload: any,
    type: string,
    field: string,
    value?: {length?: number },
    validate: boolean
}

export interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            min?: number,
            error: any
        },
    }
}


const initialState: Form = {
    valid: false,
    data: {
        state: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        county: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        caseType: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        language: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        description: {
            required: true,
            added: false,
            value: null,
            error: null,
        },
        business_name: {
            required: false,
            value: null,
            added: false,
            error: null
        }
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);

const CaseForm = (state = initialState, action: Action) => {
    switch (action.type) {
        case 'CASE_FORM_ADD_CHANGE':
            return CaseFormValidator({...state.data}, action);
        case 'RESET_CASE_FORM':
            return _.cloneDeep(baseState);
        default:
            return state;
    }
};

export default CaseForm;
